import { useNavigate } from "react-router-dom";
import TaskManagerIcon from "@assets/icons/task-manager.tsx";
import classNames from "classnames";

export const TaskManagerButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/task-manager");
  };

  return (
    <button
      className={classNames("header-actions__button")}
      onClick={handleClick}
    >
      <TaskManagerIcon />
    </button>
  );
};
